<template>
    <el-dialog v-model="visible" :show-close="false" width="500" @click.stop>
        <template #header="{ close, titleId, titleClass }">
            <div class="folder-info-header">
                <h4 :id="titleId" :class="titleClass">选择目录</h4>
                <div class="folder-info-close" @click.stop="close">×</div>
            </div>
        </template>
        <div class="folder-select">
            <div class="folder-select-title">
                <template v-for="(item, index) in path" :key="index">
                    <div class="map-folder" :class="index == path.length - 1 ? 'map-folder-active' : ''"
                        @click="toFolder(index)">
                        {{ item.name }}
                    </div>
                    <span v-if="index < path.length - 1"
                        class="map-folder-separator icon-glyphicon-chevron-right"></span>
                </template>
            </div>
            <div class="folder-select-content">
                <div class="folder-select-item" v-for="(item, index) in folderList" :key="index"
                    @click="inFolder(item)">
                    <img src="@/assets/images/icon/folder.png">
                    <div class="folder-select-item-name">{{ item.fileName }}</div>
                </div>
            </div>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="confirmSelect">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>

import { useMapStore } from '@/stores/mapStore';

export default {
    name: 'FolderSelect',
    components: {

    },
    data() {
        return {
            visible: false,
            path: [
                {
                    name: '工作台',
                    id: null
                }
            ],
            atlasList: [],
            folderList: [],
            mapStore: null
        }
    },
    computed: {

    },
    mounted() {
        this.mapStore = useMapStore();
        this.changeFolder();
    },
    methods: {
        open() {
            this.visible = true;
        },
        inFolder(item) {
            this.path.push({
                name: item.fileName,
                id: item.id,
            });
            this.changeFolder();
        },
        toFolder(index) {
            this.path = this.path.slice(0, index + 1);
            this.changeFolder();
        },
        changeFolder() {
            let folder = this.path[this.path.length - 1];
            this.folderList = this.mapStore.folderList.filter(item => item.pid === folder.id);
            this.atlasList = this.mapStore.atlasList.filter(item => item.folderId === folder.id);
        },
        confirmSelect() {
            let folder = this.path[this.path.length - 1];
            if (folder) {
                this.$emit('confirm', folder);
            }
            this.visible = false;
        },
        handleClose() {
            
        }
    }
}

</script>

<style scoped>
.folder-select {
    padding: 10px;
}

.el-dialog {
    padding: 0px !important;
}

.folder-info-close {
    color: #fff;
    font-size: 26px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
}

.folder-info-header {
    position: relative;
    height: 46px;
    padding: 12px;
    background-color: #1b2d3e;
    color: #fff;
    border-radius:
        5px 5px 0 0;

}

.folder-info-header h4 {
    color: #fff;
}

.folder-select-title {
    width: 100%;
    height: auto;
    display: inline-block;
}

.folder-select-content {
    width: 100%;
    margin-left: 10px;
}
.folder-select-item{
    width: 100%;
    display: inline-block;
}
.folder-select-item img {
    width: 16px;
    height: 16px;
    float: left;
}
.folder-select-item-name {
    float: left;
    margin-left: 10px; 
}
.dialog-footer{
    margin-right: 10px;
    padding-bottom: 10px;
}
.dialog-footer button{
    margin-bottom: 10px;
}
</style>